import Layout from './Layout'
import Feedback from './Feedback'

export { Layout, Feedback }


// WEBPACK FOOTER //
// ./src/features/Feedback/components/index.js